import styled from 'styled-components'

export const MenuOption = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  color: ${(p) => (p.disabled ? 'rgba(32, 32, 32, 0.45)' : 'rgb(32, 32, 32)')};
  opacity: ${(p) => (p.disabled ? '0.85' : 1)};
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  &:hover {
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  }
`;

export const MenuListFooter = styled.div`
  padding: 16px;
  border-top: 1px solid rgba(32, 32, 32, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MenuListActions = styled.div`
  display: flex;
`;
